import { render, staticRenderFns } from "./listaProduto.vue?vue&type=template&id=bd82d274&scoped=true&"
import script from "./listaProduto.vue?vue&type=script&lang=js&"
export * from "./listaProduto.vue?vue&type=script&lang=js&"
import style0 from "./listaProduto.vue?vue&type=style&index=0&id=bd82d274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd82d274",
  null
  
)

export default component.exports